import React from "react";
import PhysiotherapyServices from "../nursingcare/PhysiotherapyServices";

function BedsideAttendantLongterm() {
  return <PhysiotherapyServices serviceId={3} />;
}

export default BedsideAttendantLongterm;
